import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Comparison from './components/Comparison';
import Projects from './components/Projects';
import Benefits from './components/Benefits';
import Target from './components/Target';
import Company from './components/Company';
import Flow from './components/Flow';
import FAQ from './components/FAQ';
import RegistrationForm from './components/RegistrationForm';
import Header from './components/Header';
import Footer from './components/Footer';

export default function HomePage() {
  const scrollToRegistration = () => {
    const element = document.getElementById('registration');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-[#0d1b2e]">
      <Header onCTAClick={scrollToRegistration} />
      <Hero onCTAClick={scrollToRegistration} />
      <About />
      <Comparison />
      <Projects />
      <Benefits />
      <Target />
      <Company />
      <Flow />
      <FAQ />
      <RegistrationForm />
      
      {/* 最下部CTA */}
      <section className="py-12 bg-[#112240]">
        <div className="container mx-auto px-4 text-center">
          <button
            onClick={scrollToRegistration}
            className="inline-block px-12 py-4 bg-amber-500 text-[#0a1628] font-bold text-lg rounded-lg hover:bg-amber-400 transition-colors whitespace-nowrap cursor-pointer"
          >
            今すぐ無料登録
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}